import React, { Component } from "react";
import YETwoFirstLeft from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoFirstPage/YETwoFirstLeft";
import YETwoFirstRight from "./YETwoFirstRight";
import { connect } from "react-redux";
import QVFourFirstLeft from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourFirstPage/QVFourFirstLeft";
import TableQuadrantsFirstLeft from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageOne/TableQuadrantsFirstLeft";
import SecondPageComponents from "views/Pma/PmaEditor/SecondPageComponents";

class YETwoFirstPage extends Component {
  render() {
    const {
      auth,
      agentData,
      hoData,
      currentArea,
      mlsAreas,
      navbarData,
      printVersion,
      fromEditor,
      version,
      viewingGeneratedCL,
      coverPageDetails,
      quarterlyAreaTable,
      quarterlyCityTable,
      aprilData,
      demoAccountHOName,
      demoAccountCoverPhoto,
      demoAccountAreaName,
      testimonials,
      typeOfVersion,
      handlePropertyHighlightDialog,
      quadrantModalOpen,
      quadrantDetails,
      isDemo,
      bubbleBoxes,
      altAgentData,
      volunteerDetails,
      hasFlippedTeam,
      MQCityDetails,
      dashboardValuation,
      agentFocusInfoList,
      designDetailsInfoList,
      tpTrends2WatchList,
      miniTableDetailsDTO,
      showAllEditButtons,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;
    let { propertyPhotoDetailsDTO } = this.props;
    const { mlsAreaID } = currentArea;

    let useYeTwoFirstLeft = true;
    let showTableQuadrants = false;
    if (fromEditor && printVersion) {
      return (
        <div
          className={
            "pma-page-container " +
            (printVersion
              ? "ye2-print-page-container"
              : "ye2-pma-editor-page-container") +
            (fromEditor ? " from-editor-column" : "")
          }
        >
          {/*<div className="change-backpage-btn-container">
          <div className="change-backpage-btn">
            <p className="change-backpage-btn-text">Change Backpage</p>
          </div>
        </div>*/}
          <YETwoFirstRight
            auth={auth}
            agentData={agentData}
            hoData={hoData}
            navbarData={navbarData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            currentArea={currentArea}
            mlsAreas={mlsAreas}
            viewingGeneratedCL={viewingGeneratedCL}
            coverPageDetails={coverPageDetails}
            aprilData={aprilData}
            demoAccountCoverPhoto={demoAccountCoverPhoto}
            demoAccountAreaName={demoAccountAreaName}
            typeOfVersion={typeOfVersion}
            quarterlyAreaTable={quarterlyAreaTable}
            isDemo={isDemo}
            quadrantModalOpen={quadrantModalOpen}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
          />

          <SecondPageComponents
            currentArea={currentArea}
            hoData={hoData}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            hasFlippedTeam={hasFlippedTeam}
            aprilData={aprilData}
            MQCityDetails={MQCityDetails}
            dashboardValuation={dashboardValuation}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            tpTrends2WatchList={tpTrends2WatchList}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
            keyMarketAvgsList={keyMarketAvgsList}
            showMedian={showMedian}
            priceRangeDashBoardDetailsDTOArea={
              priceRangeDashBoardDetailsDTOArea
            }
            priceRangeDashBoardDetailsDTOCity={
              priceRangeDashBoardDetailsDTOCity
            }
          />
        </div>
      );
    } else {
      return (
        <div
          className={
            "pma-page-container " +
            (printVersion
              ? "ye2-print-page-container"
              : "ye2-pma-editor-page-container") +
            (fromEditor ? " from-editor-column" : "")
          }
        >
          {/*<div className="change-backpage-btn-container">
          <div className="change-backpage-btn">
            <p className="change-backpage-btn-text">Change Backpage</p>
          </div>
        </div>*/}
          {useYeTwoFirstLeft ? (
            <YETwoFirstLeft
              auth={auth}
              agentData={agentData}
              hoData={hoData}
              currentArea={currentArea}
              mlsAreas={mlsAreas}
              printVersion={printVersion}
              fromEditor={fromEditor}
              version={version}
              aprilData={aprilData}
              demoAccountHOName={demoAccountHOName}
              demoAccountAreaName={demoAccountAreaName}
              coverPageDetails={coverPageDetails}
              testimonials={testimonials}
              handlePropertyHighlightDialog={handlePropertyHighlightDialog}
              propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
              quarterlyAreaTable={quarterlyAreaTable}
              mlsAreaID={mlsAreaID}
              isDemo={isDemo}
              bubbleBoxes={bubbleBoxes}
              quadrantDetails={quadrantDetails}
              agentFocusInfoList={agentFocusInfoList}
              designDetailsInfoList={designDetailsInfoList}
              quadrantModalOpen={quadrantModalOpen}
              altAgentData={altAgentData}
              volunteerDetails={volunteerDetails}
              showAllEditButtons={showAllEditButtons}
            />
          ) : showTableQuadrants ? (
            <TableQuadrantsFirstLeft
              agentData={agentData}
              hoData={hoData}
              currentArea={currentArea}
              printVersion={printVersion}
              fromEditor={fromEditor}
              version={version}
              mlsAreas={mlsAreas}
              coverPageDetails={coverPageDetails}
              quarterlyAreaTable={quarterlyAreaTable}
              testimonials={testimonials}
              quadrantModalOpen={quadrantModalOpen}
              quadrantDetails={quadrantDetails}
              propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
              isDemo={isDemo}
            />
          ) : (
            <QVFourFirstLeft
              agentData={agentData}
              hoData={hoData}
              currentArea={currentArea}
              printVersion={printVersion}
              version={version}
              mlsAreas={mlsAreas}
              coverPageDetails={coverPageDetails}
              quarterlyAreaTable={quarterlyAreaTable}
              testimonials={testimonials}
              quadrantModalOpen={quadrantModalOpen}
              quadrantDetails={quadrantDetails}
              isDemo={isDemo}
              bubbleBoxes={bubbleBoxes}
            />
          )}
          <YETwoFirstRight
            auth={auth}
            agentData={agentData}
            hoData={hoData}
            navbarData={navbarData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            version={version}
            currentArea={currentArea}
            mlsAreas={mlsAreas}
            viewingGeneratedCL={viewingGeneratedCL}
            coverPageDetails={coverPageDetails}
            aprilData={aprilData}
            demoAccountCoverPhoto={demoAccountCoverPhoto}
            demoAccountAreaName={demoAccountAreaName}
            typeOfVersion={typeOfVersion}
            quarterlyAreaTable={quarterlyAreaTable}
            isDemo={isDemo}
            quadrantModalOpen={quadrantModalOpen}
            showAllEditButtons={showAllEditButtons}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    quadrantModalOpen: state.pma.quadrantModalOpen,
    // quadrantDetails:  state.pma.quadrantDetails,
  };
};
export default connect(mapStateToProps)(YETwoFirstPage);
